export enum NavigateType {
	First = 1,
	Last = 2,
	Previous = 3,
	Next = 4,
}
